export const getSettingValue = (settings, settingName) => {
	const selectedSetting = settings.find((setting) => {
		return setting.key === settingName;
	});
	return selectedSetting?.value ?? null;
};
